import extractDomain from './utils/extractDomain';
import { addClassList } from './utils/addClassList';
import { appendToParent, prependChild } from './utils/appendToParent';
import { createElement } from './utils/createElement';
import { getAttributes } from './utils/getAttributes';
import getFirstSiblingWithClass from './utils/getFirstSiblingWithClass';
import loaderImg from '../src/assets/loader.gif';
let autopopTriggered = false;

//OF-1734
let vehicleData = null;
function updateVehicleData(newData) {
  vehicleData = newData;
  //console.log("Vehicle data updated:", vehicleData);
}

class BuyerCall {
  constructor({
    parentWebSite = '',
    utmParams = null,
    classList = '',
    buttonImgurl = '',
    subTitle = '',
    colorPrimary,
    colorSecondary,
    infoSectionBackground,
    formLogo,
    submitButtonText,
    inventoryLinkText,
    mainmessage,
    lowestonly,
    additionalParams,
    pic,
    dcv,
    rpl,
    formid,
    template,
    vin,
    odometer,
    cdsid,
    purchase,
    msrp,
    downpayment,
    NoPaymentSuccessMessage,
    disclaimer,
    apiparam,
    gtmid,
    url = 'http://localhost:3000/',
    title = 'Launch Button',
    parentDiv,
    isModal = false,
    buyyerElement,
    buyerCallInputs = {},
    customerDetails = {},
    innerHTML = 'widget button',
    createIframe = true,
    buttonPrimary = '',
    buttonSecondary = '',
    vehicleData = null,
    isInitial = true,
  } = {}) {
    this.parentWebSite = parentWebSite;
    this.buttonPrimary = buttonPrimary;
    this.buttonSecondary = buttonSecondary;
    this.buttonImgurl = buttonImgurl;
    this.innerHTML = innerHTML;
    this.customerDetails = customerDetails;
    this.colorPrimary = colorPrimary;
    this.colorSecondary = colorSecondary;
    this.utmParams = utmParams;
    this.infoSectionBackground = infoSectionBackground;
    this.formLogo = formLogo;
    this.submitButtonText = submitButtonText;
    this.inventoryLinkText = inventoryLinkText;
    this.mainmessage = mainmessage;
    this.lowestonly = lowestonly;
    this.additionalParams = additionalParams;
    this.pic = pic;
    this.dcv = dcv;
    this.rpl = rpl;
    this.formid = formid;
    this.template = template;
    this.vin = vin;
    this.odometer = odometer;
    this.cdsid = cdsid;
    this.purchase = purchase;
    this.msrp = msrp;
    this.downpayment = downpayment;
    this.NoPaymentSuccessMessage = NoPaymentSuccessMessage;
    this.disclaimer = disclaimer;
    this.apiparam = apiparam;
    this.gtmid = gtmid;
    this.isModal = isModal;
    this.url = url;
    this.classes = classList;
    this.lauchButton = buyyerElement;
    this.buttonTitle = title;
    this.buttonSubTitle = subTitle;
    this.open = false;
    this.parentDiv = parentDiv;
    this.buyerCallInputs = buyerCallInputs;
    this.titleContainer = null;
    this.buttonFallBacktitleContainer = null;
    this.iWindow = null;
    this.createIframe = createIframe;
    this.iframeContainer = null;
    this.imgContainer = null;
    this.isInitial = isInitial;
    this.vehicleData = vehicleData;
    this.initialize();
  }

  // Initializing
  initialize() {
    if (this.createIframe) {
      // Creating Container for Iframe
      this.iframeContainer = createElement('div');
      addClassList(this.iframeContainer, [
        'cta__buyerCall__modalLaunch__hidden',
        'cta__buyerCall__modalLaunch__modal_container',
      ]);

      // Creating Iframe
      this.iframe = createElement('iframe');
      addClassList(
        this.iframe,
        'cta__buyerCall__modalLaunch__modal_container_iframe',
      );
      this.iframe.src = this.url; //url of the widget modal
      this.iframe.style.opacity = 0;
      this.iframe.setAttribute('allowTransparency', 'true'); // Correct attribute name and value
      this.iframe.setAttribute('background', 'transparent');
    }
    // Adding additional classes to button
    (this.classes ? this.classes.split(' ') : []).forEach((item) => {
      addClassList(this.lauchButton, item);
    });

    // If its a button trigering modal
    if (this.isModal === 'true') {
      // if (this.createIframe) {
      //   document.body.append(this.iframeContainer);
      // }
      // Disbale the button initially
      this.lauchButton.disabled = true;

      // Add additional classes to button
      addClassList(
        this.lauchButton,
        'cta__buyerCall__modalLaunch_buttonLaunch',
      );

      // Create fallback container for title to be placed inside button when iframe is not yet loaded
      this.buttonFallBacktitleContainer = createElement('div');
      addClassList(
        this.buttonFallBacktitleContainer,
        'cta__buyerCall_titlecontainer',
      );
      this.fallbacktitle = createElement('span');
      addClassList(this.fallbacktitle, 'loader-g');
      this.fallbacktitle.src = loaderImg;
      appendToParent(this.buttonFallBacktitleContainer, this.fallbacktitle);
      appendToParent(this.lauchButton, this.buttonFallBacktitleContainer);
      if (this.buttonPrimary) {
        document.documentElement.style.setProperty(
          '--primaryctabutton',
          this.buttonPrimary,
        );
      }
      if (this.buttonSecondary) {
        document.documentElement.style.setProperty(
          '--secondaryctabutton',
          this.buttonSecondary,
        );
      }

      // Add Launch button to DOM to the parent element
      appendToParent(this.parentDiv, this.lauchButton);

      // Add listner to button onclick
      this.lauchButton.addEventListener('click', this.modalOpen.bind(this));
      
      //OF-1842 auto pop open modal
      const urlParams = new URLSearchParams(window.location.search);
      if (
        ['1', 'true'].includes(urlParams.get('autopop_preapp')) &&
        this.isModal === 'true' &&
        !autopopTriggered
      ) {
        autopopTriggered = true;
        setTimeout(() => this.modalOpen(), 100);
      }

    }
    if (!(this.isModal === 'true')) {
      this.iframeContainer.classList.remove(
        'cta__buyerCall__modalLaunch__modal_container',
      );

      addClassList(this.iframeContainer, 'cta__buyerCall__modalLaunch__screen');
      addClassList(
        this.lauchButton,
        'cta__buyerCall__modalLaunch_isModal_false',
      );

      appendToParent(this.lauchButton, this.iframeContainer);

      this.iframe.addEventListener('load', () => {
        // Code to be executed after the iframe has loaded
        this.iframe.style.opacity = 1;
        this.iframeContainer.classList.remove(
          'cta__buyerCall__modalLaunch__hidden',
        );
      });
    }

    if (this.createIframe && !(this.isModal === 'true')) {
      this.iframe.addEventListener('load', () => {
        addClassList(this.iframeContainer, 'iFrameLoaded');
        const lauchButtonsTitleContainers = document.querySelectorAll(
          '.cta__buyerCall_titlecontainer',
        );
        if (this.isModal === 'false') {
          this.iWindow = this.iframe.contentWindow;
          this.modalOpen.call(this);
        }
        if (
          this.isModal === 'true' &&
          lauchButtonsTitleContainers instanceof NodeList &&
          lauchButtonsTitleContainers.length > 0
        ) {
          lauchButtonsTitleContainers.forEach((lauchButtonsTitleContainer) => {
            // this.iWindow = this.iframe.contentWindow;
            const parentNode = lauchButtonsTitleContainer.parentNode; // Which is the button
            const childElementToRemove = parentNode.childNodes[0]; // Replace 'childClass' with the class name of the element you want to remove
            // Check if the child element was found
            if (childElementToRemove) {
              // Remove the child element from the parent
              parentNode.removeChild(childElementToRemove);
            }

            const wrapperElement = getFirstSiblingWithClass(
              parentNode,
              'cta__buyerCall__modalLaunch',
            );
            let buttonTitle = getAttributes(wrapperElement, 'title');
            let buttonsubTitle = getAttributes(wrapperElement, 'subTitle');
            let buttonImageUrl = getAttributes(
              wrapperElement,
              'button-img-url',
            );
            // Create container for title to be placed inside button
            this.titleContainer = createElement('div');
            addClassList(this.titleContainer, 'cta__buyerCall_titlecontainer');
            this.title = createElement('h4');
            this.title.innerHTML = buttonTitle;
            appendToParent(this.titleContainer, this.title);
            this.subTitle = createElement('h6');
            this.subTitle.innerHTML = buttonsubTitle;
            appendToParent(this.titleContainer, this.subTitle);
            appendToParent(parentNode, this.titleContainer);
            // Add image to launch button if any
            if (buttonImageUrl && buttonImageUrl.trim() !== '') {
              this.imgContainer = createElement('div');
              addClassList(this.imgContainer, 'cta__buyerCall_imgContainer');
              this.img = createElement('img');
              this.img.src = buttonImageUrl;
              appendToParent(this.imgContainer, this.img);
              appendToParent(parentNode, this.imgContainer);
            } else {
              // Center align title and subtitle if no image is provided
              titleContainer.style.textAlign = 'center';
            }
            parentNode.disabled = false;
          });
        }
      });
    }
    if (this.isModal === 'true' && !this.isInitial) {
      var _iframeContainer = document.getElementsByClassName(
        'cta__buyerCall__modalLaunch__modal_container',
      );
      if (
        _iframeContainer.length &&
        _iframeContainer[0].classList.contains('iFrameLoaded')
      ) {
        const lauchButtonsTitleContainers = document.querySelectorAll(
          '.cta__buyerCall_titlecontainer',
        );

        if (
          this.isModal === 'true' &&
          lauchButtonsTitleContainers instanceof NodeList &&
          lauchButtonsTitleContainers.length > 0
        ) {
          lauchButtonsTitleContainers.forEach((lauchButtonsTitleContainer) => {
            const parentNode = lauchButtonsTitleContainer.parentNode; // Which is the button
            const childElementToRemove = parentNode.childNodes[0]; // Replace 'childClass' with the class name of the element you
            if (parentNode.childNodes.length !== 2) {
              // Check if the child element was found
              if (childElementToRemove) {
                // Remove the child element from the parent
                parentNode.removeChild(childElementToRemove);
              }

              const wrapperElement = getFirstSiblingWithClass(
                parentNode,
                'cta__buyerCall__modalLaunch',
              );
              let buttonTitle = getAttributes(wrapperElement, 'title');
              let buttonsubTitle = getAttributes(wrapperElement, 'subTitle');
              let buttonImageUrl = getAttributes(
                wrapperElement,
                'button-img-url',
              );
              // Create container for title to be placed inside button
              this.titleContainer = createElement('div');
              addClassList(
                this.titleContainer,
                'cta__buyerCall_titlecontainer',
              );
              this.title = createElement('h4');
              this.title.innerHTML = buttonTitle;
              appendToParent(this.titleContainer, this.title);
              this.subTitle = createElement('h6');
              this.subTitle.innerHTML = buttonsubTitle;
              appendToParent(this.titleContainer, this.subTitle);
              appendToParent(parentNode, this.titleContainer);
              // Add image to launch button if any
              if (buttonImageUrl) {
                this.imgContainer = createElement('div');
                addClassList(this.imgContainer, 'cta__buyerCall_imgContainer');
                this.img = createElement('img');
                this.img.src = buttonImageUrl;
                appendToParent(this.imgContainer, this.img);
              } else {
                // Center align title and subtitle if no image is provided
                this.titleContainer.style.textAlign = 'center';
              }
              appendToParent(parentNode, this.imgContainer);
              parentNode.disabled = false;
            }
          });
        }
      }
    }
    if (
      // (this.isModal === 'true' && this.createIframe) ||
      this.isModal === 'false'
    ) {
      // Appending Iframe to Iframe Container
      appendToParent(this.iframeContainer, this.iframe);
    }

    // Listening to child iframe communications
    window.addEventListener('message', (event) => {
      if (event.origin !== extractDomain(this.url).replace(/\/+$/, '')) {
        // Ensure the message is from a trusted source (e.g., the child iframe's origin)
        return;
      }
      const receivedMessage = event.data;
      const iframeContainer = document.querySelector(
        '.cta__buyerCall__modalLaunch__modal_container',
      );
      if (receivedMessage.btnClose === true) {
        //OF-1734 Reset the iframe by reassigning its src, which reloads its content
        const childIframe = document.querySelector('.cta__buyerCall__modalLaunch__modal_container_iframe');
        if (childIframe) {
          childIframe.src = this.url;
        }
        addClassList(iframeContainer, 'cta__buyerCall__modalLaunch__hidden');
      }
    });
  }
  //function for open the modal
  modalOpen() {
    const button = this.lauchButton; // This is the button clicked
    const vehicleInfo = JSON.parse(button.getAttribute('data-vehicle-info')); // Get the correct vehicle data from the button
  
    if (this.isModal === 'true') {
      if (!document.querySelector('.cta__buyerCall__modalLaunch__modal_container')) {
        this.bc_createIframe();
  
        var observer = new MutationObserver((mutationsList, observer) => {
          var modalContainer = document.querySelector('.cta__buyerCall__modalLaunch__modal_container');
  
          if (modalContainer && modalContainer.classList.contains('iFrameLoaded')) {
            // The element has appeared and has the iFrameLoaded class
            const iframeContainer = document.querySelector('.cta__buyerCall__modalLaunch__modal_container');
            const isOpen = !iframeContainer.classList.contains('cta__buyerCall__modalLaunch__hidden');
            const childIframe = document.getElementsByClassName('cta__buyerCall__modalLaunch__modal_container_iframe')[0];
  
            const inputData = {
              isModal: this.isModal,
              customerDetails: this.customerDetails,
              infoSectionBackground: this.infoSectionBackground,
              formLogo: this.formLogo,
              submitButtonText: this.submitButtonText,
              inventoryLinkText: this.inventoryLinkText,
              mainmessage: this.mainmessage,
              lowestonly: this.lowestonly,
              additionalParams: this.additionalParams,
              pic: this.pic,
              dcv: this.dcv,
              rpl: this.rpl,
              formid: this.formid,
              template: this.template,
              vin: this.vin,
              odometer: this.odometer,
              cdsid: this.cdsid,
              purchase: this.purchase,
              msrp: this.msrp,
              downpayment: this.downpayment,
              NoPaymentSuccessMessage: this.NoPaymentSuccessMessage,
              disclaimer: this.disclaimer,
              apiparam: this.apiparam,
              gtmid: this.gtmid,
              colorPrimary: this.colorPrimary,
              colorSecondary: this.colorSecondary,
              url: this.url,
              parentWebSite: this.parentWebSite,
              fromOrigin: true,
              utmParams: this.utmParams,
              vehicleData: vehicleInfo, // Use the vehicle data from the button
              ...this.buyerCallInputs,
            };
  
            const urlFormatted = this.url.replace(/\/+$/, '');
            if (!isOpen) {
              //console.log("inputData--->", inputData);
              childIframe.contentWindow.postMessage(inputData, urlFormatted);
              iframeContainer.classList.remove('cta__buyerCall__modalLaunch__hidden');
              childIframe.style.opacity = 1;
            } else {
              addClassList(iframeContainer, 'cta__buyerCall__modalLaunch__hidden');
              childIframe.style.opacity = 0;
            }
  
            // Stop observing after the element is found and the code is executed
            observer.disconnect();
          }
        });
        // Start observing the document's body for changes
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });
      } else {
        const iframeContainer = document.querySelector('.cta__buyerCall__modalLaunch__modal_container');
        const isOpen = !iframeContainer.classList.contains('cta__buyerCall__modalLaunch__hidden');
        const childIframe = document.getElementsByClassName('cta__buyerCall__modalLaunch__modal_container_iframe')[0];
  
        const inputData = {
          isModal: this.isModal,
          customerDetails: this.customerDetails,
          infoSectionBackground: this.infoSectionBackground,
          formLogo: this.formLogo,
          submitButtonText: this.submitButtonText,
          inventoryLinkText: this.inventoryLinkText,
          mainmessage: this.mainmessage,
          lowestonly: this.lowestonly,
          additionalParams: this.additionalParams,
          pic: this.pic,
          dcv: this.dcv,
          rpl: this.rpl,
          formid: this.formid,
          template: this.template,
          vin: this.vin,
          odometer: this.odometer,
          cdsid: this.cdsid,
          purchase: this.purchase,
          msrp: this.msrp,
          downpayment: this.downpayment,
          NoPaymentSuccessMessage: this.NoPaymentSuccessMessage,
          disclaimer: this.disclaimer,
          apiparam: this.apiparam,
          gtmid: this.gtmid,
          colorPrimary: this.colorPrimary,
          colorSecondary: this.colorSecondary,
          url: this.url,
          parentWebSite: this.parentWebSite,
          fromOrigin: true,
          utmParams: this.utmParams,
          vehicleData: vehicleInfo, // Again, using the vehicle data from the button
          ...this.buyerCallInputs,
        };
  
        const urlFormatted = this.url.replace(/\/+$/, '');
        if (!isOpen) {
          //console.log("inputData--->", inputData);
          childIframe.contentWindow.postMessage(inputData, urlFormatted);
          iframeContainer.classList.remove('cta__buyerCall__modalLaunch__hidden');
          childIframe.style.opacity = 1;
        } else {
          addClassList(iframeContainer, 'cta__buyerCall__modalLaunch__hidden');
          childIframe.style.opacity = 0;
        }
      }
    } else {
      const isOpen = false;
      const childIframe = document.getElementsByClassName('cta__buyerCall__modalLaunch__modal_container_iframe')[0];
      const inputData = {
        isModal: this.isModal,
        customerDetails: this.customerDetails,
        infoSectionBackground: this.infoSectionBackground,
        formLogo: this.formLogo,
        submitButtonText: this.submitButtonText,
        inventoryLinkText: this.inventoryLinkText,
        mainmessage: this.mainmessage,
        lowestonly: this.lowestonly,
        additionalParams: this.additionalParams,
        pic: this.pic,
        dcv: this.dcv,
        rpl: this.rpl,
        formid: this.formid,
        template: this.template,
        vin: this.vin,
        odometer: this.odometer,
        cdsid: this.cdsid,
        purchase: this.purchase,
        msrp: this.msrp,
        downpayment: this.downpayment,
        NoPaymentSuccessMessage: this.NoPaymentSuccessMessage,
        disclaimer: this.disclaimer,
        apiparam: this.apiparam,
        gtmid: this.gtmid,
        colorPrimary: this.colorPrimary,
        colorSecondary: this.colorSecondary,
        url: this.url,
        parentWebSite: this.parentWebSite,
        fromOrigin: true,
        utmParams: this.utmParams,
        vehicleData: vehicleInfo, // Use the vehicle data from the button
        ...this.buyerCallInputs,
      };
  
      const urlFormatted = this.url.replace(/\/+$/, '');
      if (!isOpen) {
        //console.log("inputData--->", inputData);
        childIframe.contentWindow.postMessage(inputData, urlFormatted);
        // iframeContainer.classList.remove('cta__buyerCall__modalLaunch__hidden');
        childIframe.style.opacity = 1;
      }
    }
  }
  
  bc_createIframe() {
    this.iframeContainer = createElement('div');
    addClassList(this.iframeContainer, [
      'cta__buyerCall__modalLaunch__hidden',
      'cta__buyerCall__modalLaunch__modal_container',
    ]);
    document.body.append(this.iframeContainer);

    // Creating Iframe
    this.iframe = createElement('iframe');
    addClassList(
      this.iframe,
      'cta__buyerCall__modalLaunch__modal_container_iframe',
    );
    this.iframe.src = this.url; //url of the widget modal
    this.iframe.style.opacity = 0;
    this.iframe.setAttribute('allowTransparency', 'true'); // Correct attribute name and value
    this.iframe.setAttribute('background', 'transparent');

    this.iframe.addEventListener('load', () => {
      addClassList(this.iframeContainer, 'iFrameLoaded');
    });

    appendToParent(this.iframeContainer, this.iframe);
  }
}

function createStyles() {
  const styleTag = createElement('style');
  document.head.appendChild(styleTag);
  styleTag.innerHTML = `
    :root {
      --primaryctabutton: #13b85a;

      /* secondary color applicable for icon background */
      --secondaryctabutton: #13b85a2b;
    }
    .cta__buyerCall__modalLaunch_buttonLaunch {
      width:100%;
      min-height:70px;
      background-color: var(--primaryctabutton);
      border-radius: 3px;
      border-style: none;
      box-sizing: border-box;
      color: #FFFFFF !important;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      list-style: none;
      margin: 0;
      outline: none;
      padding: 10px 16px;
      position: relative;
      text-align: center;
      text-decoration: none;
      transition: color 100ms;
      vertical-align: baseline;
      user-select: none;
      -webkit-user-select: none;
      touch-action: manipulation;  
    }
    .cta__buyerCall__modalLaunch_isModal_false{
      min-height:900px;
      display: flex;
    }
    @media (max-width: 576px) {
      .cta__buyerCall__modalLaunch_isModal_false{
        min-height:2050px;
        display: flex;
      }
    }
    .cta__buyerCall__modalLaunch_buttonLaunch:hover,
    .cta__buyerCall__modalLaunch_buttonLaunch:focus {
      background-color: var(--secondaryctabutton);
    }
   .cta__buyerCall_imgContainer {
    width: 30%;
    margin: auto;
    display: block;
   }
   .cta__buyerCall_titlecontainer {
    width: 100%;
    height: 100%;
    margin: auto;
    display: block;
    /*padding-right: 5%;*/
    justify-content: center;
    align-items: normal;
    text-align: left;
    flex-direction: column;
   }
   .cta__buyerCall_titlecontainer > h4 {
    margin: 0;
    padding: 0;
    font-weight: 800;
    color: #fff;
    font-size: 14px !important;
   }
   .cta__buyerCall_titlecontainer > h6 {
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 12px !important;
    line-height: 20px;
    color: #fff;
   }
   .loader-g {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;
    display: inline-block;
  }
  .loader-g::before , .loader-g::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 3px solid #B2B2B2;
    // animation: prixClipFix 2s linear infinite ;
    animation: prixClipFix 2s  infinite ;
  }
  .loader-g::after{
    border-color: #fff;
    animation: prixClipFix 2s linear infinite , rotate 0.5s linear infinite reverse;
    inset: 6px;
  }
  
  @keyframes rotate {
    0%   {transform: rotate(0deg)}
    100%   {transform: rotate(360deg)}
  }
  
  @keyframes prixClipFix {
      0% {clip-path:polygon(50% 50%,50% 0,100% 0,100% 100%,0 100%,0 0)}
      100% {clip-path:polygon(50% 50%,50% 0,100% 0,100% 100%,0 100%,0 0)}
  }
   .cta__buyerCall_imgContainer > img{
    width: 100%;
    height: 100%;
    padding-horizontal: 5%;
   }

    .cta__buyerCall__modalLaunch__hidden {
      display: none;
    }
    .cta__buyerCall__modalLaunch__screen {
      width: 100%;
    }
    .cta__buyerCall__modalLaunch__button_container {
      background-color: transparent;
      width: "100%";
      height: "100%";
    }

    .cta__buyerCall__modalLaunch__modal_container {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 3000;
      display: block;
      background-color: transparent;
      width: 100%;
      height: 100%;
    
    }
    .cta__buyerCall__modalLaunch__modal_container.cta__buyerCall__modalLaunch__hidden {
      display: none;
    }

    .cta__buyerCall__modalLaunch__modal_container_iframe {
      background-color: transparent;
      width: 100%;
      height: 100%;
      border: 0;
    }
    .cta__buyerCall__modalLaunch__modal_container_iframe .modal {
      display: block !important;
      opacity: 1 !important;
      background-color: transparent !important;
    }
    @media (max-width: 992px) {
      .cta__buyerCall_imgContainer > img {
        width: 100%;
      }
    }
 `;
}

function bc_handleButtonLoader() {
  setTimeout(() => {
    // addClassList(this.iframeContainer, 'iFrameLoaded');
    const lauchButtonsTitleContainers = document.querySelectorAll(
      '.cta__buyerCall_titlecontainer',
    );
    // if (this.isModal === 'false') {
    //   this.iWindow = this.iframe.contentWindow;
    //   this.modalOpen.call(this);
    // }
    if (
      // this.isModal === 'true' &&
      lauchButtonsTitleContainers instanceof NodeList &&
      lauchButtonsTitleContainers.length > 0
    ) {
      lauchButtonsTitleContainers.forEach((lauchButtonsTitleContainer) => {
        // this.iWindow = this.iframe.contentWindow;
        const parentNode = lauchButtonsTitleContainer.parentNode; // Which is the button
        const childElementToRemove = parentNode.childNodes[0]; // Replace 'childClass' with the class name of the element you want to remove

        if (
          !(
            childElementToRemove &&
            childElementToRemove.querySelector('span.loader-g')
          )
        ) {
          return;
        }
        // Check if the child element was found
        if (childElementToRemove) {
          // Remove the child element from the parent
          parentNode.removeChild(childElementToRemove);
        }

        const wrapperElement = getFirstSiblingWithClass(
          parentNode,
          'cta__buyerCall__modalLaunch',
        );
        let buttonTitle = getAttributes(wrapperElement, 'title');
        let buttonsubTitle = getAttributes(wrapperElement, 'subTitle');
        let buttonImageUrl = getAttributes(wrapperElement, 'button-img-url');
        // Create container for title to be placed inside button
        const titleContainer = createElement('div');
        addClassList(titleContainer, 'cta__buyerCall_titlecontainer');
        const title = createElement('h4');
        title.innerHTML = buttonTitle;
        appendToParent(titleContainer, title);
        const subTitle = createElement('h6');
        subTitle.innerHTML = buttonsubTitle;
        appendToParent(titleContainer, subTitle);
        appendToParent(parentNode, titleContainer);
        // Add image to launch button if any
        if (buttonImageUrl) {
          const imgContainer = createElement('div');
          addClassList(imgContainer, 'cta__buyerCall_imgContainer');
          const img = createElement('img');
          img.src = buttonImageUrl;
          appendToParent(imgContainer, img);
          appendToParent(parentNode, imgContainer);
        } else {
          // Center align title and subtitle if no image is provided
          titleContainer.style.textAlign = 'center';
        }

        parentNode.disabled = false;
      });
    }
  }, 700);
}

// Function to handle the network request completion
function processCompletedNetworkRequest(eventFired = false) {
  // Page is fully loaded, and the network requests are also completed.

  const buyyerCallWidgetDiv = document.querySelectorAll(
    '.cta__buyerCall__modalLaunch:not(.eventAttactchCompleted)',
  );
  let formIndex = 0;
  buyyerCallWidgetDiv.forEach((elem, inx) => {
    // if (isInitial) {
    addClassList(elem, 'eventAttactchCompleted');
    // }

    if (elem.tagName === 'DIV') {
      const isModal = elem.getAttribute('isModal');
      const buyyerCallWidgetButton = document.createElement('button');
      const parentDiv = elem.parentNode;
      
      //OF-1859
      const rawBuyerCallInputs = getAttributes(elem, 'buyerCallInputs');
      const buyerCallInputs = rawBuyerCallInputs
        ? JSON.parse(rawBuyerCallInputs)
        : {};
      const urlParams = new URLSearchParams(window.location.search);
      const overrideMap = {
        autopop_fn:   'firstName',
        autopop_ln:   'lastName',
        autopop_pn:   'phno',
        autopop_em:   'email',
        autopop_addr: 'address',
        autopop_city: 'city',
        autopop_st:   'state',
        autopop_zc:   'zip',
      };
      Object.entries(overrideMap).forEach(([paramKey, fieldName]) => {
        if (urlParams.has(paramKey)) {
          buyerCallInputs[fieldName] = urlParams.get(paramKey);
        }
      });
      
      if (isModal === 'true') {
        elem.style.display = 'none';
        new BuyerCall({
          parentWebSite: getAttributes(elem, 'parentWebSite'),
          buyyerElement: buyyerCallWidgetButton,
          utmParams: getUTMParameters(getAttributes(elem, 'url')),
          isModal,
          parentDiv,
          classList: getAttributes(elem, 'classList'),
          url: getAttributes(elem, 'url'),
          title: getAttributes(elem, 'title'),
          /*buyerCallInputs: getAttributes(elem, 'buyerCallInputs')
            ? JSON.parse(getAttributes(elem, 'buyerCallInputs'))
            : {},*/
          buyerCallInputs,
          subTitle: getAttributes(elem, 'subTitle'),
          innerHTML: elem.innerHTML,
          colorPrimary: getAttributes(elem, 'colorPrimary'),
          colorSecondary: getAttributes(elem, 'colorSecondary'),
          buttonImgurl: getAttributes(elem, 'button-img-url'),
          customerDetails: getAttributes(elem, 'customerDetails')
            ? JSON.parse(getAttributes(elem, 'customerDetails'))
            : {},
          infoSectionBackground: getAttributes(elem, 'infoSectionBackground'),
          formLogo: getAttributes(elem, 'formLogo'),
          submitButtonText: getAttributes(elem, 'submitButtonText'),
          inventoryLinkText: getAttributes(elem, 'inventoryLinkText'),
          mainmessage: getAttributes(elem, 'mainmessage'),
          lowestonly: getAttributes(elem, 'lowestonly'),
          additionalParams: getAttributes(elem, 'additionalParams'),
          pic: getAttributes(elem, 'pic'),
          dcv: getAttributes(elem, 'dcv'),
          rpl: getAttributes(elem, 'rpl'),
          formid: getAttributes(elem, 'formid'),
          template: getAttributes(elem, 'template'),
          vin: getAttributes(elem, 'vin'),
          odometer: getAttributes(elem, 'odometer'),
          cdsid: getAttributes(elem, 'cdsid'),
          purchase: getAttributes(elem, 'purchase'),
          msrp: getAttributes(elem, 'msrp'),
          downpayment: getAttributes(elem, 'downpayment'),
          NoPaymentSuccessMessage: getAttributes(elem, 'NoPaymentSuccessMessage'),
          disclaimer: getAttributes(elem, 'disclaimer'),
          apiparam: getAttributes(elem, 'apiparam'),
          gtmid: getAttributes(elem, 'gtmid'),
          // createIframe: inx === 0 && !eventFired,
          createIframe: false,
          buttonPrimary: getAttributes(elem, 'buttonPrimary')
            ? getAttributes(elem, 'buttonPrimary')
            : '#1d328b',
          buttonSecondary: getAttributes(elem, 'buttonSecondary')
            ? getAttributes(elem, 'buttonSecondary')
            : '#1a2c7a',
          isInitial: !eventFired,
          vehicleData,
        });
      } else {
        //for single form
        formIndex++;
        if (formIndex === 1) {
          new BuyerCall({
            buyyerElement: elem,
            utmParams: getUTMParameters(getAttributes(elem, 'url')),
            isModal,
            parentDiv,
            classList: getAttributes(elem, 'classList'),
            url: getAttributes(elem, 'url'),
            colorPrimary: getAttributes(elem, 'colorPrimary'),
            colorSecondary: getAttributes(elem, 'colorSecondary'),
            infoSectionBackground: getAttributes(elem, 'infoSectionBackground'),
            formLogo: getAttributes(elem, 'formLogo'),
            submitButtonText: getAttributes(elem, 'submitButtonText'),
            inventoryLinkText: getAttributes(elem, 'inventoryLinkText'),
            mainmessage: getAttributes(elem, 'mainmessage'),
            lowestonly: getAttributes(elem, 'lowestonly'),
            additionalParams: getAttributes(elem, 'additionalParams'),
            pic: getAttributes(elem, 'pic'),
            dcv: getAttributes(elem, 'dcv'),
            rpl: getAttributes(elem, 'rpl'),
            formid: getAttributes(elem, 'formid'),
            template: getAttributes(elem, 'template'),
            vin: getAttributes(elem, 'vin'),
            odometer: getAttributes(elem, 'odometer'),
            cdsid: getAttributes(elem, 'cdsid'),
            purchase: getAttributes(elem, 'purchase'),
            msrp: getAttributes(elem, 'msrp'),
            downpayment: getAttributes(elem, 'downpayment'),
            NoPaymentSuccessMessage: getAttributes(elem, 'NoPaymentSuccessMessage'),
            disclaimer: getAttributes(elem, 'disclaimer'),
            apiparam: getAttributes(elem, 'apiparam'),
            gtmid: getAttributes(elem, 'gtmid'),
            /*buyerCallInputs: getAttributes(elem, 'buyerCallInputs')
              ? JSON.parse(getAttributes(elem, 'buyerCallInputs'))
              : {},*/
            buyerCallInputs,
            customerDetails: getAttributes(elem, 'customerDetails')
              ? JSON.parse(getAttributes(elem, 'customerDetails'))
              : {},
            isInitial: !eventFired,
            vehicleData,
          });
        }
      }
    }
  });

  bc_handleButtonLoader();
}

function getUTMParameters(url) {
  var urlParams = new URLSearchParams(new URL(url).search);
  var utmData = {};

  urlParams.forEach((value, key) => {
    key = key.toLowerCase();
    if (key.startsWith('utm_')) {
      utmData[key] = value;
    }
  });
  return utmData;
}

//OF-1513
const targetClassName = 'cta__buyerCall__modalLaunch';
let bc_widget_eventFired = false;
//let vehicleData = null;

function handleTargetBCWidgetDivAppearance() {
  const targetDiv = document.querySelector(`.${targetClassName}`);
  if (targetDiv) {
    processCompletedNetworkRequest(bc_widget_eventFired);
    if (!bc_widget_eventFired) {
      createStyles();
      bc_widget_eventFired = true;
    }
  }
}

(() => {
  const observer = new MutationObserver(handleTargetBCWidgetDivAppearance);
  observer.observe(document, { childList: true, subtree: true });
  handleTargetBCWidgetDivAppearance();

  (async APILoader => {
    const API = await APILoader.create();
    API.subscribe('vehicle-shown-v1', ev => {
      const vehicleData = ev.payload;
      // Check for the multiple vehicle page indicator.
      const isMultipleVehicles = document.querySelector('.vehicle-card[data-uuid]') !== null;

      if (isMultipleVehicles) {
        // Multiple vehicle page logic.
        const uuid = vehicleData?.uuid || vehicleData?.vehicleId || vehicleData?.id;
        if (!uuid) return;

        const card = document.querySelector(`.vehicle-card[data-uuid="${uuid}"]`);
        if (!card) return;

        // Optionally update vehicleData globally.
        updateVehicleData(vehicleData);

        let attempts = 0;
        const maxAttempts = 20;
        const interval = setInterval(() => {
          const widget = card.querySelector('.cta__buyerCall__widgetcontainer');
          const button = widget?.querySelector('.cta__buyerCall__modalLaunch_buttonLaunch');

          if (button) {
            button.setAttribute('data-vehicle-info', JSON.stringify(vehicleData));
            clearInterval(interval);
          } else if (++attempts >= maxAttempts) {
            clearInterval(interval);
          }
        }, 100);
      } else {
        // Single vehicle page logic.
        const waitForElements = () => {
          const buttons = document.querySelectorAll('.cta__buyerCall__modalLaunch_buttonLaunch');
          const widgetContainers = document.querySelectorAll('.cta__buyerCall__widgetcontainer');

          // If both elements are found, update data
          if (buttons.length > 0 && widgetContainers.length > 0) {
            buttons.forEach(button => {
              // Optionally check for the widget container if needed:
              const widgetContainer = button.closest('.cta__buyerCall__widgetcontainer');
              if (widgetContainer) {
                button.setAttribute('data-vehicle-info', JSON.stringify(vehicleData));
              }
            });
            return true; // Found the elements, stop checking.
          }
          return false; // Keep checking.
        };

        let attempts = 0;
        const maxAttempts = 20;
        const interval = setInterval(() => {
          if (waitForElements() || ++attempts >= maxAttempts) {
            clearInterval(interval);
          }
        }, 100);
      }
    });
  })(window.DDC.APILoader);
})();

// OF-1842: Grab GA4 values from parent page to send to modal
(function() {
  let attempts = 0;
  const maxAttempts = 5;
  let gaAttempts = 0;
  const maxGAAttempts = 5;

  function waitForLaunchEl() {
    const launchEl = document.querySelector('.cta__buyerCall__modalLaunch');
    if (!launchEl) {
      attempts++;
      if (attempts >= maxAttempts) {
        return console.warn('Launch element not found.');
      }
      //console.warn(`Launch element not found, retrying (${attempts}/${maxAttempts})...`);
      return setTimeout(waitForLaunchEl, 200);
    }

    function mergeAndSet() {
      gaAttempts++;
      const dl = window.dataLayer || [];
      const ascDL = window.asc_dataLayer || [];
      const needsAsc = typeof window.asc_dataLayer !== 'undefined';

      const raw = launchEl.getAttribute('gtmid') || '';
      const attrIds = raw.split(',').map(s => s.trim()).filter(Boolean);

      const configIds = dl.flatMap(item => {
        try {
          if (item && item[0] === 'config' && typeof item[1] === 'string') {
            return [item[1]];
          }
        } catch (e) {}
        if (item && typeof item === 'object' && item.send_to) {
          return Array.isArray(item.send_to) ? item.send_to : [item.send_to];
        }
        return [];
      });

      const ascIds = ascDL.flatMap(item => {
        if (item && item.send_to) {
          return Array.isArray(item.send_to) ? item.send_to : [item.send_to];
        }
        return [];
      });

      if (configIds.length === 0 || (needsAsc && ascIds.length === 0)) {
        if (gaAttempts >= maxGAAttempts) {
          //console.warn('Max attempts reached. GA4 dataLayer values not found.');
          return;
        }
        //console.warn(`Waiting for GA4 config${needsAsc ? ' and asc_dataLayer' : ''} values... (${gaAttempts}/${maxGAAttempts})`);
        return setTimeout(mergeAndSet, 200);
      }

      const allIds = Array.from(new Set([...attrIds, ...configIds, ...ascIds]));
      launchEl.setAttribute('gtmid', allIds.join(','));

      //console.log('from attribute:', attrIds);
      //console.log('from dataLayer config:', configIds);
      //console.log('from asc_dataLayer:', ascIds);
      //console.log('final gtmid attribute:', allIds);
    }
    mergeAndSet();
  }
  waitForLaunchEl();
})();
